import {Toaster} from './components/Toaster/Toaster';

export const toaster = new Toaster();
